import { runClientComponent } from '../../_common/client/client-component-runner';
import { DeliveryComponent } from './delivery.component';

runClientComponent({ DeliveryComponent });
